import { render, staticRenderFns } from "./RouterLinkColumnRenderer.vue?vue&type=template&id=45285c22&"
import script from "./RouterLinkColumnRenderer.vue?vue&type=script&lang=js&"
export * from "./RouterLinkColumnRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports